module.exports = __webpack_public_path__ + "static/media/lobby.2ff99163.png";